import { render, staticRenderFns } from "./m-dialog-document-fields-form.vue?vue&type=template&id=1629c92e&scoped=true&lang=pug"
import script from "./m-dialog-document-fields-form.vue?vue&type=script&lang=js"
export * from "./m-dialog-document-fields-form.vue?vue&type=script&lang=js"
import style0 from "./m-dialog-document-fields-form.vue?vue&type=style&index=0&id=1629c92e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1629c92e",
  null
  
)

export default component.exports